const PHOTOS_PICKER_API = "https://photospicker.googleapis.com/v1";

export const createPickerSession = async ({ accessToken }) => {
  try {
    const resp = await fetch(`${PHOTOS_PICKER_API}/sessions`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pickingConfig: {
          maxItemCount: "20",
        },
      }),
    });

    const data = await resp.json();
    return data;
  } catch (err) {
    console.error("Failed to create picker session:", err);
  }
  return null;
};

export const deletePickerSession = async ({ accessToken, id }) => {
  try {
    await fetch(`${PHOTOS_PICKER_API}/sessions/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  } catch (err) {
    console.error("Error deleting picker session:", err);
  }
};

export const checkMediaItemsReady = async ({ accessToken, id }) => {
  try {
    const resp = await fetch(`${PHOTOS_PICKER_API}/sessions/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await resp.json();
    return data.mediaItemsSet ? true : false;
  } catch (err) {
    console.error("Error checking media items readiness:", err);
  }
  return false;
};

export const listSelectedMediaItems = async ({ accessToken, id }) => {
  const resp = await fetch(`${PHOTOS_PICKER_API}/mediaItems?sessionId=${id}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  const data = await resp.json();
  return data.mediaItems || [];
};

export const getFileSize = async ({ downloadUrl, accessToken }) => {
  try {
    const response = await fetch(downloadUrl, {
      method: "HEAD",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const size = response.headers.get("content-length");
    return Number(size);
  } catch (err) {
    console.error("Error fetching file size:", err);
  }
  return 0;
};
